/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { IRule } from '../domain/rule.entity';

const INITIAL_STATE: RulesEngineState = {
  selectedRule: null,
  lastState: {
    page: 1,
    criteria: '',
  },
};

export const NAMESPACE = 'RULES-ENGINE';

export const RulesEngineActions = {
  INIT: `${NAMESPACE}.INIT`,
  INIT_PAGESTATE: `${NAMESPACE}.INIT_PAGESTATE`,
  SET_SELECTED_RULE: `${NAMESPACE}.SET_SELECTED_RULE`,
  RELOAD_USER: `${NAMESPACE}.RELOAD_USER`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
  SET_LAST_STATE: `${NAMESPACE}.SET_LAST_STATE`,
  KEEP_LAST_STATE: `${NAMESPACE}.KEEP_LAST_STATE`,
  CLEAR_LAST_STATE: `${NAMESPACE}.CLEAR_LAST_STATE`,
};

export const RulesEngineReducer = (state: RulesEngineState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case RulesEngineActions.INIT: //this step check from local storage and restore value if exist
      return {
        ...state,
        selectedRule: INITIAL_STATE.selectedRule,
      };
    case RulesEngineActions.INIT_PAGESTATE: //this step check from local storage and restore value if exist
      return {
        ...state,
        LastState: INITIAL_STATE.lastState,
      };
    case RulesEngineActions.SET_SELECTED_RULE:
      return {
        ...state,
        selectedRule: action.payload,
      };
    case RulesEngineActions.SET_LAST_STATE:
      return {
        ...state,
        lastState: action.payload,
      };
    case RulesEngineActions.CLEAR_LAST_STATE:
      return {
        ...state,
        lastState: INITIAL_STATE.lastState,
      };
    default:
      return state;
  }
};

export interface RulesEngineState {
  selectedRule: IRule;
  lastState: {
    page: number;
    criteria: string;
  };
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
